import store from '@/store'

export default async (to, _from, next) => {
  const user = store.getters['auth/user']
  if (!user?.id) {
    next({
      name: 'shared.login',
      query: {
        redirect: to?.fullPath || '/'
      }
    })
  } else {
    next()
  }
}
